import { categories } from "@redotech/redo-flows-common/triggers";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const skipDraftMessage = {
  name: "skipDraftMessage" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    category: createEnum(categories),
  }),
  output: z.object({ success: z.boolean() }),
};
